import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import ModuleDimensions, { Props } from '../_components/ModuleDimensions';
import { ModuleOnValueUpdate, ModuleOnMultipleValueUpdate } from '../_actions/ModuleActions';
import { OnChangeLockRatio } from '../../Document/_actions/DocumentActions';

const mapStateToProps = (store:Store, props:Props) => ({
	width: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'width']),
	height: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'height']),
	rotation: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'rotation']),
	lockRatio: store.getIn(['create', 'moduleList', 'modules', props.moduleId, 'lockRatio']),
	documentWidth: store.getIn(['create', 'document', 'width']),
	documentHeight: store.getIn(['create', 'document', 'height']),
	isAttached: store.getIn(['create', 'document', 'attachedModule']) === props.moduleId,
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onWidthChange: (width: number) => dispatch(ModuleOnValueUpdate(props.moduleId, 'width', width)),
	onHeightChange: (height: number) => dispatch(ModuleOnValueUpdate(props.moduleId, 'height', height)),
	updateModule: (moduleId:string, updates:{[key:string] : any}) => dispatch(ModuleOnMultipleValueUpdate(moduleId, updates)),
	onLockRatioChange: (value:boolean) => dispatch(ModuleOnValueUpdate(props.moduleId, 'lockRatio', value)),
	toggleLockRatio: (lockRatio: boolean) => dispatch(OnChangeLockRatio(lockRatio)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ModuleDimensions);